import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import MobileTabComponent from '../../common/components/MobileTabComponent';
export default class ForumNewDiscussionTabItem extends MobileTabComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "openComposer", () => {
      if (!app.session.user) {
        return;
      }
      return app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
        user: app.session.user
      }).then(() => app.composer.show());
    });
  }
  view() {
    const {
      icon,
      label
    } = this.attrs.definition;
    return m(Button, {
      className: "Button Button--link MobileTab-item",
      icon: icon,
      onclick: this.openComposer
    }, label);
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'forum/components/ForumNewDiscussionTabItem', ForumNewDiscussionTabItem);